export const CART_HYDRATION_BLOCKED_KEY = 'cart:blocked';

function canUseSessionStorage(): boolean {
  return typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';
}

export function isCartHydrationBlocked(): boolean {
  if (!canUseSessionStorage()) {
    return false;
  }

  try {
    return sessionStorage.getItem(CART_HYDRATION_BLOCKED_KEY) === '1';
  } catch {
    return false;
  }
}

export function blockCartHydration(): void {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    sessionStorage.setItem(CART_HYDRATION_BLOCKED_KEY, '1');
  } catch {
    // ignore
  }
}

export function unblockCartHydration(): void {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    sessionStorage.removeItem(CART_HYDRATION_BLOCKED_KEY);
  } catch {
    // ignore
  }
}
